import script from "./heatmap-month-trend.vue?vue&type=script&setup=true&lang=js"
export * from "./heatmap-month-trend.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__